import SetupLicenseForm from './SetupLicenseForm'

export default SetupLicenseForm
